import React, { Component, Fragment, createRef } from 'react';
import { connect } from 'react-redux';
import { Field } from 'react-final-form-html5-validation';
import { OnChange } from 'react-final-form-listeners';
import * as actions from '../../actions';
import { 
    isRequiredDate,
    isRequiredQuestionSelection,
    isRequiredText,
    isRequiredPhoneNumber,
    isRequiredStateSelection,
    isRequiredZipCode,
    numberValidator,
    isRequired,
    isRequiredSelection
} from '../helpers/Validation';
import DropdownDate from "react-dropdown-date";
import { stateList, textField } from '../helpers/Form';

class Step3 extends Component {

    constructor(props) {
        super(props)
        this.state = {
            patientResides: null,
            residentPhoneOne: null,
            residentPhoneTwo: null,
            residentPhoneThree: null
        }
    }

    updateHiddenInput = (name,
        value, e=null) => {
        this.setState({
            ...this.state,
            [name]: value
        });
    }

    facilityPhoneTwo = createRef();
    facilityPhoneThree = createRef();
    pharmacyPhoneTwo = createRef();
    pharmacyPhoneThree = createRef();

    render() {
        const { formattedExpectedDischargeDate  } = this.state;
        const { currentStep } = this.props; 
        const { 
            patientResides,
            facilityPhoneOne,
            facilityPhoneTwo,
            facilityPhoneThree,
            pharmacyPhoneOne,
            pharmacyPhoneTwo,
            pharmacyPhoneThree,
            expectedDischargeDate,
            medicare
        } = this.props.questionOptions;

        const today = new Date();
        const tomorrow =  new Date(today.getFullYear() + 3, 12, 31);
        var releaseDate = today.getFullYear() + 3 + "-" + "12" + "-" + "31";
        var startDate = today.getFullYear() + "-" + "12" + "-" + "31";

        return (
            <Fragment>
                <div className="row mobile-step-header">
                    <div className="col-sm-2 col-2">
                        <span className="header-number">{currentStep}</span>
                    </div>
                    <div className="col-sm-10 col-10 pl-0">
                        <h3 className="euclid">FACILITY ADDRESS</h3>
                        <div className="d-inline-block"><i>All questions are required unless marked optional.</i></div>
                        <div className="text-right d-inline-block float-right pr-2">*required</div>
                    </div>
                    <div class="row grey-spacer-col-1"></div>
                </div>

                <div className="row spacer-medium">&nbsp;</div>
                <div className="row">
                    <div className="col-sm">
                        <div className="form-group"> 
                            <Field className="form-control" name="patientResides" component="input" defaultValue={patientResides} validate={isRequiredQuestionSelection}>
                                {({ input, meta }) => ( 
                                    <Fragment> 
                                        <label className={meta.error && meta.touched ? "error" : "fancy-label"} htmlFor="patientResides">Facility Address*</label> 
                                        <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                    </Fragment> 
                                )}
                            </Field>

                            <div className="radio-field">
                                <Field name="patientResides" type="radio" >
                                    {({ input, meta }) => {
                                        return(
                                            <Fragment>
                                                <input
                                                    id="patientResidesFacility"
                                                    name={input.name}
                                                    type="radio"
                                                    onClick={(e) => this.props.questionAnswer("patientResides", "In a Skilled Nursing Facility/Nursing Home")}
                                                />
                                            </Fragment>);
                                    }}
                                </Field>
                                <label className="" htmlFor="patientResidesFacility">In a skilled nursing facility/nursing home</label>
                            </div>
                            <div className="radio-field">
                                <Field name="patientResides" type="radio" >
                                    {({ input, meta }) => {
                                        return(
                                            <Fragment>
                                                <input
                                                    id="patientResidesHome"
                                                    name={input.name}
                                                    type="radio"
                                                    onClick={(e) => this.props.questionAnswer("patientResides", "In Assisted Living")}
                                                />
                                            </Fragment>);
                                    }}
                                </Field>
                                <label className="" htmlFor="patientResidesHome">In assisted living</label>
                            </div>
                            <Field className="form-control" name="patientResides" component="input" defaultValue={patientResides} validate={isRequiredQuestionSelection}>
                                {({ input, meta }) => ( 
                                    <Fragment> 
                                        <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                        {meta.error && meta.touched && meta.error } 
                                    </Fragment> 
                                )}
                            </Field>

                        </div>
                    </div>
                </div>
                <div className="row">
                        <div className="col-sm-6">
                            <Field
                                name="primaryFacilityContact"
                                label="Primary facility contact (optional)"
                                placeholder="Primary facility contact"
                                component={textField}
                            />
                        </div>
                        <div className="col-sm-6">
                            <Field
                                name="jobTitle"
                                label="Job title (optional)"
                                placeholder="Job title"
                                component={textField}
                            />
                        </div>
                </div>
                <div className="row">
                    <div className="col-sm">
                        <Field
                            name="facilityName"
                            label="Facility name*"
                            placeholder="Facility name"
                            component={textField}
                            validate={isRequiredText}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm">
                        <Field
                            name="facilityAddress"
                            label="Address*"
                            placeholder="Address"
                            component={textField}
                            validate={isRequiredText}
                        />
                    </div>
                    <div className="col-sm">
                        <Field
                            name="facilityCity"
                            label="City*"
                            placeholder="City"
                            component={textField}
                            validate={isRequiredText}
                            customDivClass={{marginBottom: '0px'}}
                        />
                    </div>
                </div>
                <div className="row spacer-large mobile-sm">&nbsp;</div>
                <div className="row">
                    <div className="col-sm-4">
                        <div className="form-group" style={{paddingBottom: '30px'}}>
                            <Field
                                name="facilityState"
                                component="select"
                                validate={isRequiredStateSelection}
                            >                        
                                {({ input, meta }) => (
                                    <Fragment>
                                        <label className={meta.error && meta.touched ? "error" : "fancy-label"} htmlFor="state" style={{marginBottom: '0px', calc: '(100% - 15px)'}}>State*</label>
                                        <select {...input} className={meta.error && meta.touched ? "select-state-css select-css error" : "select-state-css select-css"} type="select" style={{marginTop: '0px'}}>
                                            <option name="" value="">- Select state -</option>
                                            {Object.entries(stateList).map(function(state) {
                                                return (<option key={state[0]} name="state" value={state[0]}>{state[1]}</option>);
                                            })}
                                        </select>
                                        {meta.error && meta.touched && meta.error }          
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                    </div>
                    <div className="col-sm-2">
                        <Field
                            name="facilityZipCode"
                            label="Zip code*"
                            placeholder="Zip code"
                            component={textField}
                            validate={isRequiredZipCode}
                            maxLength={5}
                            inputMode="numeric"
                            customInputClass={{marginTop: '0'}}
                            labelPosition='top'
                        />
                    </div>
                    <div className="col-sm-6">
                            <Field 
                                name="facilityPhoneNumber"
                                component="input"
                                defaultValue={facilityPhoneOne + facilityPhoneTwo + facilityPhoneThree}
                                validate={isRequiredPhoneNumber}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <label className={meta.error && meta.touched ? "fancy-label error" : "fancy-label"}>Phone number*</label> 
                                    </Fragment>
                                )}
                            </Field> 
                            <div className="phone-group phone-group-validate">
                                <Field name="facilityPhoneOne" component="input" validate={isRequired}>
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input 
                                                {...input}
                                                className={meta.error && meta.touched ? "form-control inline-phone phone-area-code error" : "form-control inline-phone phone-area-code"}
                                                type="text"
                                                maxLength="3"
                                                placeholder="123"
                                            />
                                            {meta.error && meta.touched && meta.error }
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="facilityPhoneOne">
                                    {(value, previous) => {
                                        if(numberValidator(value)) {
                                            this.props.questionAnswer("facilityPhoneOne", value);
                                            if(value.length === 3) {
                                                this.facilityPhoneTwo.current.focus();
                                            }         
                                        }             
                                    }}
                                </OnChange>
                                <Field name="facilityPhoneTwo" component="input" validate={isRequired} >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input 
                                                {...input}
                                                className={meta.error && meta.touched ? "form-control inline-phone phone-prefix error" : "form-control inline-phone phone-prefix"}
                                                type="text"
                                                maxLength="3"
                                                placeholder="456"
                                                ref={this.facilityPhoneTwo} 
                                            />
                                            {meta.error && meta.touched && meta.error }
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="facilityPhoneTwo">
                                    {(value, previous) => {
                                        if(numberValidator(value)) {
                                            this.props.questionAnswer("facilityPhoneTwo", value);
                                            if(value.length === 3) {
                                                this.facilityPhoneThree.current.focus();
                                            }
                                        }
                                    }}
                                </OnChange>
                                <Field name="facilityPhoneThree" component="input" validate={isRequired}>
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input 
                                            className={meta.error && meta.touched ? "form-control inline-phone phone-line-number error" : "form-control inline-phone phone-line-number"}
                                            {...input} type="text" maxLength="4" placeholder="7890" ref={this.facilityPhoneThree} />
                                            {meta.error && meta.touched && meta.error }
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="facilityPhoneThree">
                                    {(value, previous) => {   
                                        if(numberValidator(value)) {         
                                            this.props.questionAnswer("facilityPhoneThree", value);
                                        }
                                    }}
                                </OnChange>
                            </div>
                            <Field 
                                name="facilityPhoneNumber"
                                component="input"
                                defaultValue={facilityPhoneOne + facilityPhoneTwo + facilityPhoneThree}
                                validate={isRequiredPhoneNumber}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                        {meta.error && meta.touched && meta.error }
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                </div>
                <div className="row spacer-large mobile-sm">&nbsp;</div>
                <div className="row">
                    <div className="col-sm">
                        <Field name="pharmacyName" component="input" validate={isRequiredText}>
                            {({ input, meta }) => (
                                <Fragment>
                                    <label className={meta.error && meta.touched ? "fancy-label error" : "fancy-label"} htmlFor="pharmacyName">Pharmacy name*</label>
                                    <input 
                                        {...input} 
                                        className={"form-control full-width-input " + (meta.error && meta.touched ? "error" : "") + (meta.valid ? "valid" : "")} 
                                        style={{marginTop: '0'}}
                                        type="text" />
                                    {meta.error && meta.touched && <span>{meta.error}</span>}          
                                </Fragment>
                            )}
                        </Field>
                    </div>
                    <div className="row spacer-large mobile-sm">&nbsp;</div>
                    <div className="col-sm-6">
                        <div className="phone-group phone-group-validate">
                            <Field
                                name="pharmacyPhoneNumber"
                                component="input"
                                defaultValue={pharmacyPhoneOne + pharmacyPhoneTwo + pharmacyPhoneThree}
                                validate={isRequiredPhoneNumber}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <label className={meta.error && meta.touched ? "fancy-label error" : "fancy-label"}>Pharmacy phone*</label> 
                                    </Fragment>
                                )}
                            </Field>
                            <div className="phone-group phone-group-validate">
                                <Field name="pharmacyPhoneOne" component="input" validate={isRequired}>
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                className={meta.error && meta.touched ? "form-control inline-phone phone-area-code error" : "form-control inline-phone phone-area-code"}
                                                type="text"
                                                maxLength="3"
                                                placeholder="123"
                                            />
                                            {meta.error && meta.touched && meta.error }
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="pharmacyPhoneOne">
                                    {(value, previous) => {
                                        if(numberValidator(value)) {
                                            this.props.questionAnswer("pharmacyPhoneOne", value);
                                            if(value.length === 3) {
                                                this.pharmacyPhoneTwo.current.focus();
                                            }                    
                                        }  
                                    }}
                                </OnChange>
                                <Field name="pharmacyPhoneTwo" component="input" validate={isRequired} >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                className={meta.error && meta.touched ? "form-control inline-phone phone-prefix error" : "form-control inline-phone phone-prefix"}
                                                type="text"
                                                maxLength="3"
                                                placeholder="456"
                                                ref={this.pharmacyPhoneTwo}
                                            />
                                            {meta.error && meta.touched && meta.error }
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="pharmacyPhoneTwo">
                                    {(value, previous) => {
                                        if(numberValidator(value)) {
                                            this.props.questionAnswer("pharmacyPhoneTwo", value);
                                            if(value.length === 3) {
                                                this.pharmacyPhoneThree.current.focus();
                                            }
                                        }                 
                                    }}
                                </OnChange>
                                <Field name="pharmacyPhoneThree" component="input" validate={isRequired}>
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                className={meta.error && meta.touched ? "form-control inline-phone phone-line-number error" : "form-control inline-phone phone-line-number"}
                                                type="text"
                                                maxLength="4"
                                                placeholder="7890"
                                                ref={this.pharmacyPhoneThree}
                                            />
                                            {meta.error && meta.touched && meta.error }
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="pharmacyPhoneThree">
                                    {(value, previous) => {           
                                        if(numberValidator(value)) {
                                            this.props.questionAnswer("pharmacyPhoneThree", value);
                                        }
                                    }}
                                </OnChange>
                            </div>
                            <Field
                                name="pharmacyPhoneNumber"
                                component="input"
                                defaultValue={pharmacyPhoneOne + pharmacyPhoneTwo + pharmacyPhoneThree}
                                validate={isRequiredPhoneNumber}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                        {meta.error && meta.touched && meta.error }
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                    </div>
                </div>
                <div className="row spacer-small desktop">&nbsp;</div>
                <div className="row spacer-large mobile-sm">&nbsp;</div>
                <div className="row">
                    <div className="col-sm-6">
                        <label className="fancy-label" htmlFor="expectedDischargeDate">Expected discharge date (optional)</label>
                        <DropdownDate
                            startDate={startDate}
                            endDate={releaseDate}
                            onDateChange={date => {
                                this.props.questionAnswer("expectedDischargeDate", date);
                            }}
                            order={
                                ['month', 'day', 'year'] // Order of the dropdowns
                            }
                            defaultValues={
                                {
                                    month: "Month", 
                                    day: "Day",
                                    year: "Year"
                                }
                            }
                            selectedDate={expectedDischargeDate ? expectedDischargeDate : ""}
                            options={
                                {
                                    yearReverse: true
                                }
                            }
                            classes={
                                {
                                    month: 'dateDropDownMonthClass',
                                    day: 'dateDropDownDayClass',
                                    year: 'dateDropDownYearClass'
                                }
                            }
                        />
                        <Field 
                            name="expectedDischargeDate"
                            component="input"
                            defaultValue={expectedDischargeDate}
                        >
                            {({ input, meta }) => (
                                <Fragment>
                                    <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                    {meta.error && meta.touched && meta.error }
                                </Fragment>
                            )}
                        </Field>
                    </div>
                    <div className="row spacer-large mobile-sm">&nbsp;</div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <Field name="medicare" component="input" defaultValue={medicare} validate={isRequiredQuestionSelection}>
                                {({ input, meta }) => (
                                    <Fragment>
                                        <label className={meta.error && meta.touched ? "error" : ""}>Is the resident currently covered under Medicare Part A*</label>
                                    </Fragment>
                                )}
                            </Field>
                            <div className="row">
                                <div className="col">
                                    <div className="radio-field">
                                        <Field name="medicare" type="radio" >
                                            {({ input, meta }) => {
                                                return(
                                                    <Fragment>
                                                        <input
                                                            id="no"
                                                            name={input.name}
                                                            type="radio"
                                                            value="no"
                                                            onClick={(e) => this.props.questionAnswer("medicare", "no")}
                                                        />
                                                    </Fragment>);
                                            }}
                                        </Field>
                                        <label className="" htmlFor="no">No</label>
                                    </div>
                                    <div className="radio-field">
                                        <Field name="medicare" type="radio" >
                                            {({ input, meta }) => {
                                            return(
                                                <Fragment>
                                                    <input
                                                        id="yes"
                                                        name={input.name}
                                                        type="radio"
                                                        value="yes"
                                                        onClick={(e) => this.props.questionAnswer("medicare", "yes")}
                                                    />
                                                </Fragment>)
                                        }}
                                        </Field>
                                        <label className="" htmlFor="yes">Yes</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Field name="medicare" component="input" defaultValue={medicare} validate={isRequiredQuestionSelection}>
                            {({ input, meta }) => (
                                <Fragment>
                                    <input {...input} type="text" className="form-control full-width-input hidden-field" tabIndex="-1" />
                                    {meta.error && meta.touched && meta.error }
                                </Fragment>
                            )}
                        </Field>
                    </div>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    const { currentStep, questionOptions } = state;
    return { currentStep: currentStep, questionOptions: questionOptions };
}
  
  export default connect(mapStateToProps, actions)(Step3);